import 'react-perfect-scrollbar/dist/css/styles.css';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { MODAL_ANIMATIONS, MODAL_TYPES } from 'components/Modal/constants';
import { ModalContext } from 'context/ModalContext';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

interface ISpeaker {
  topSectionHeight?: number;
  external?: boolean;
}

function Speakers({ topSectionHeight, external }: ISpeaker) {
  const peopleData = useSelector((state: RootState) => state.people.people);
  const { showModal } = useContext(ModalContext);

  return (
    <div className={`${topSectionHeight ? '' : 'border'} p-4 h-auto mr-3 rounded-md w-full md:w-96 text-black text-sm`}>
      {external ? (
        <>
          {topSectionHeight ? '' : <p className="font-bold text-base mb-2">Speakers</p>}
          <div className="grid grid-cols-1 gap-2">
            {(peopleData || []).map((people: any) => (
              <div
                className="cursor-pointer relative"
                key={people.hash_id}
                onClick={() => {
                  showModal(MODAL_TYPES.profile, {
                    animation: MODAL_ANIMATIONS.unfold,
                    name: people.name,
                    title: people.title,
                    company: people.company,
                    description: people.personal_bio,
                    avatarUrl: people.photo
                  });
                }}
              >
                <div className="flex mt-2">
                  <img className="rounded-md cursor-pointer w-full" src={people.photo} alt={`Image`} />
                </div>
                <div className="w-[calc(100%-16px)] bg-black bg-opacity-50 rounded-md p-4 absolute bottom-0 text-white mx-2 mb-2">
                  <p className="font-bold">{people.name}</p>
                  <p className="mt-auto">{people.company}</p>
                  <p className="mt-2">{people.title}</p>
                </div>
              </div>
            ))}
          </div>
        </>
      ) : (
        <PerfectScrollbar
          style={{
            maxHeight: topSectionHeight ? `calc(100vh - ${topSectionHeight + 90}px)` : `calc((100vh - 100px) / 2)`
          }}
        >
          <p className="font-bold text-base mb-2">Speakers</p>
          <div className="grid grid-cols-1 gap-2">
            {(peopleData || []).map((people: any) => (
              <div
                className="cursor-pointer relative"
                key={people.hash_id}
                onClick={() => {
                  showModal(MODAL_TYPES.profile, {
                    animation: MODAL_ANIMATIONS.unfold,
                    name: people.name,
                    title: people.title,
                    company: people.company,
                    description: people.personal_bio,
                    avatarUrl: people.photo
                  });
                }}
              >
                <div className="flex mt-2">
                  <img className="rounded-md cursor-pointer w-full" src={people.photo} alt={`Image`} />
                </div>
                <div className="w-[calc(100%-16px)] bg-black bg-opacity-50 rounded-md p-4 absolute bottom-0 text-white mx-2 mb-2">
                  <p className="font-bold">{people.name}</p>
                  <p className="mt-auto">{people.company}</p>
                  <p className="mt-2">{people.title}</p>
                </div>
              </div>
            ))}
          </div>
        </PerfectScrollbar>
      )}
    </div>
  );
}

export default Speakers;
